import { formatCurrency } from '../functions'
import * as bootstrap from 'bootstrap';

export default class Products {
    constructor() {
        this.el = $('.products');
        this.maxOrderItems = this.el.data("maxorderitems");

        if (!this.el.length) {
            return false;
        }

        this.products = [];

        this.el.find('.ticket-view .addon-product.regular').each((index, el) => {
            const isGift = (el.dataset.isGift || "").toLowerCase() == 'true'
            this.products.push(new ProductSelector($(el), false, true, this.maxOrderItems, isGift));
        });

        this.el.find('.ticket-view .addon-product.sized').each((index, el) => {
            if (el.dataset.max && el.dataset.max > 0) {
                this.products.push(new ProductSelector($(el), true, true, this.maxOrderItems));
            }
        });

        this.el.find('.product.regular').each((index, el) => {
            this.products.push(new ProductSelector($(el), false, false, this.maxOrderItems));
        });

        this.el.find('.product.sized').each((index, el) => {
            if (el.dataset.max && el.dataset.max > 0) {
                this.products.push(new ProductSelector($(el), true, false, this.maxOrderItems));
            }
        });

        this.el.find('.product-details.regular').each((index, el) => {
            const isGift = (el.dataset.isGift || "").toLowerCase() == 'true'
            this.products.push(new ProductSelector($(el), false, true, this.maxOrderItems, isGift));
        });

        this.el.find('.product-details.sized').each((index, el) => {
            if (el.dataset.max && el.dataset.max > 0) {
                this.products.push(new ProductSelector($(el), true, true, this.maxOrderItems));
            }
        });

        this.el.find('.product-filter').each((index, el) => {
            new ProductFilter($(el), this.products);
        });

        $('.products-expand').each((index, el) => {
            el = $(el);
            el.on('click', function () {
                const newText = el.data('expandtext');
                const oldText = el.text();
                el.data('expandtext', oldText);
                el.text(newText);
                el.siblings('.products-expandable').toggleClass('show');
                return false;
            });
        });
    }
}

export class SelectHref {
    constructor() {
        this.el = document.querySelector('#products-mobile-selector')

        this.init = this.init.bind(this)
        this.init()
    }
    init() {
        if (!this.el) return false
        this.el.addEventListener('change', ev => {
            const location = '/Products/Category/' + this.el.value.toString()
            window.location.href = location
        })
    }
}

class ProductSelector {
    constructor(el, sizedProduct, ticketView, maxOrderItems, isGift) {
        this.el = el;
        this.sizedProduct = sizedProduct;
        this.maxItems = 10;
        this.maxOrderItems = maxOrderItems;
        this.numItems = null;
        this.enabled = !sizedProduct;
        this.selected = {}
        this.ticketView = ticketView;
        this.isGift = isGift;
        this.numItems = 0;

        this._onIncrement = this._onIncrement.bind(this);
        this._onDecrease = this._onDecrease.bind(this);
        this._onSelectSizeChange = this._onSelectSizeChange.bind(this);
        this._toggleDescription = this._toggleDescription.bind(this);
        this.showGiftPriceModal = this.showGiftPriceModal.bind(this);

        this.productMax = +this.el.data('max');

        if (this.productMax)
            this.maxItems = this.productMax;

        this.productId = this.el.data('product-id');
        this.categoryName = this.el.data('category-name');
        this.productName = this.el.data('product-name');
        this.productPrice = el.data('price');
        const sizedProd = this.el.data('sized-product');
        const rowIndex = this.el.data('row-index');
        this.product = sizedProd.product;
        this.productStock = sizedProd.optionStock;

        this.chosenProductToOption = this.el.find('input[name="productToOption"]');
        this.chosenBitSum = this.el.find('input[name="bitSum"]');
        //ADDONS for new ticket select
        this.productToOptionWithIndex = this.el.find(`input[name="Addons[${rowIndex}].ChoosenOption"]`);
        this.bitSumWithIndex = this.el.find(`input[name="Addons[${rowIndex}].BitSum"]`);
        this.addonIncButton = this.el.find('.btn-increment');
        this.addonDecButton = this.el.find('.btn-decrement');
        this.addonIncButton.on('click', this._onIncrement);
        this.addonDecButton.on('click', this._onDecrease);

        this.chosenQuantity = this.el.find('input[name="quantity"]');
        this.incBtn = this.el.find('.quantity-selector .inc');
        this.decBtn = this.el.find('.quantity-selector .dec');
        this.secondaryIncBtn = this.el.find('.selector .btn-step.subtract');
        this.secondaryDecBtn = this.el.find('.selector .btn-step.add');
        this.buyBtn = this.el.find('.buy');
        //buyBtnTicketSelect is the submit button in ticket select view. I.e for addon products
        this.buyBtnTicketSelect = document.getElementById('submitTickets');
        this.quantSel = this.el.find('.quantity-selector');
        this.inpq = this.el.find('.quantity-selector .inp-quantity');
        this.secondaryInp = this.el.find('.selector .num');
        this.soldOut = this.el.find('.sold-out');
        this.price = this.el.find('span.price');

        this.incBtn.on('click', this._onIncrement);
        this.decBtn.on('click', this._onDecrease);
        this.secondaryIncBtn.on('click', this._onDecrease);
        this.secondaryDecBtn.on('click', this._onIncrement);

        this.sel = this.el.find('.size-selector select');
        this.sel.on('change', this._onSelectSizeChange);

        this.continueButton = $('.continue .btn-continue');
        this.selectGiftPrice = this.el.find('.choose-amount');
        this.selectGiftPrice.on('click', () => { this.showGiftPriceModal(); return false; });
        this.chooseGiftAmountBtn = this.el.find('.gift-amount');
        this.chooseGiftQuantityEl = this.el.find('.choose-quantity');

        this.description = this.el.find('.product-description');
        this.descriptionShort = this.el.find('.product-description-shortened');
        this.showMore = this.el.find('.show-more');
        this.showLess = this.el.find('.show-less');
        this.showMore.on('click', this._toggleDescription);
        this.showLess.on('click', this._toggleDescription);
        if (this.description.length) {
            this._checkDescription();
        }

        if (this.sizedProduct) {
            this.secondaryIncBtn.hide();
            this.secondaryDecBtn.hide();
            this.incBtn.prop('disabled', true);
            this.incBtn.addClass('disabled');           
            this.inpq.addClass('disabled');
            this.inpq.attr('disabled', '1');
            this.decIncGroup = this.el.find('.dec-inc-group');
            const tooltipSpan = document.querySelector(`[data-sizedproduct-tooltip-id="${this.productId}"]`);
            const tooltipTitle = tooltipSpan?.dataset.tooltip || 'Du måste göra ett val';
            const tooltip = new bootstrap.Tooltip(this.decIncGroup[0], {
                trigger: 'manual',
                title: tooltipTitle,
                placement: 'top'
            });
            this.decIncGroup.on('pointerdown', () => {
                if (this.incBtn.prop('disabled'))
                {
                    tooltip.show();
                    setTimeout(() => tooltip.hide(), 2000);

                }
            });
            this._reset();
        } else {
            this._updateNumItems();
        }

        this.buyBtn.addClass('disabled');
        if (this.buyBtn.hasClass('disabled')) {
            this.buyBtn.find('button').prop('disabled', true);
        }
        this.decBtn.prop('disabled', true);
        this.decBtn.addClass('disabled');
       

    }

    _showToolTipForSizedProduct() {
        if (this.sizedProduct && this.incBtn.prop('disabled')) {
            this.incBtn.tooltip('show');
        }
    }
    _hideToolTipForSizedProduct() {
        this.incBtn.tooltip('hide');
    }
    _checkDescription() {
        let shortenedDescription = '';
        let shouldShorten = false;
        if (this.description.html().length > 250) {
            shouldShorten = true;
            shortenedDescription = this.description.html().substring(0, 250) + '...';
        } else if (this.description.html().indexOf('<br><br><br><br>') > -1) {
            shouldShorten = true;
            shortenedDescription = this.description.html().substring(0, this.description.html().indexOf('<br><br><br><br>'));
        }

        if (shouldShorten) {
            this.descriptionShort.html(shortenedDescription);
            this.description.hide();
            this.showMore.removeClass('hidden');
        }
    }

    _toggleDescription() {
        this.description.toggle();
        this.descriptionShort.toggle();
        this.showMore.toggleClass('hidden');
        this.showLess.toggleClass('hidden');
    }

    _reset() {

        for (const s of this.sel) {
            s.selectedIndex = 0;
        }

        this._disable();
        this._updateOptions();
    }

    _onSelectSizeChange(event) {
        if (event) {
            let changed = $(event.target);
            let groupId = Number(changed.data("group-id"));
            if (groupId) {
                let val = Number(changed.val());

                if (groupId && val) {
                    this.selected[groupId] = val;
                } else {
                    this.selected[groupId] = undefined;
                }
                this._updateOptions(groupId);
            }
        }
    }

    _updateOptions(justChanged) {
        if (this.sizedProduct) {
            //Clear previous addon-value 
            const inputSelector = this._getAddonInput(this.product.productId);
            if (inputSelector) {
                inputSelector.val(0);
            }
            let possibleOptions = [];
            for (const option of this.product.options) {
                let allMatch = true;

                for (const groupId of Object.keys(this.selected)) {
                    if (this.selected[groupId]) {
                        const choice = option.groupChoices[groupId];
                        if (!choice) {
                            allMatch = false;
                            break;
                        } else if (option.groupChoices[groupId].bit !== this.selected[groupId]) {
                            allMatch = false;
                            break;
                        }
                    }
                }

                if (allMatch) {
                    let stock = null;

                    if (this.productStock) {
                        for (const optionStock of this.productStock) {
                            if (optionStock.productToOption === option.productToOption && optionStock.bits === option.bits) {
                                stock = optionStock.stock;
                                break;
                            }
                        }
                    }
                    possibleOptions.push({ stock, option });
                }
            }
            let groupOptions = {};
            for (const group of Object.keys(this.product.groups)) {
                let options = [];

                for (const maybe of possibleOptions) {
                    let choice = maybe.option.groupChoices[group];
                    if (choice) {

                        let found = false;
                        for (const option of options) {
                            if (option.choice.bit === choice.bit) {
                                found = true;

                                if (maybe.stock) {
                                    if (option.remaining < maybe.stock.remaining)
                                        option.remaining = maybe.stock.remaining;
                                }

                                if (option.price.min > maybe.option.price)
                                    option.price.min = maybe.option.price;
                                if (option.price.max < maybe.option.price)
                                    option.price.max = maybe.option.price;
                            }
                        }
                        if (!found) {
                            let remaining = 10;
                            if (maybe.stock)
                                remaining = maybe.stock.remaining;

                            options.push({ remaining, choice, price: { min: maybe.option.price, max: maybe.option.price } });
                        }
                    }
                }

                if (options.length > 0)
                    groupOptions[group] = options;
            }

            let potentialMax = null;
            let priceMin = null;
            let priceMax = null;
            for (const groupId of Object.keys(groupOptions)) {
                for (const o of groupOptions[groupId]) {
                    if (!potentialMax || o.remaining < potentialMax)
                        potentialMax = o.remaining;

                    if (!priceMin || priceMin > o.price.min)
                        priceMin = o.price.min;
                    if (!priceMax || priceMax < o.price.max)
                        priceMax = o.price.max;
                }
            }
            if (potentialMax) {
                this._updateMax(potentialMax);
                if (priceMin === priceMax)
                    this.price.text(formatCurrency(priceMin));
                else
                    this.price.text(formatCurrency(priceMin) + "-" + formatCurrency(priceMax));
            }

            let allHidden = true;
            for (const undollar of this.sel) {
                const s = $(undollar);
                const groupId = s.data('group-id');
                const available = groupOptions[groupId];

                if (available) {
                    s.show();
                    $(`label[for='${s.attr('id')}']`).show();
                    allHidden = false;

                    for (const undollar2 of s.find('option')) {
                        const o = $(undollar2);
                        const val = Number(o.val());

                        if (val !== 0) {
                            let found = false;
                            for (const opt of available) {
                                if (opt.choice.bit === val) {
                                    found = true;
                                    break;
                                }
                            }

                            if (found) {
                                o.removeAttr('hidden');
                                o.removeAttr('disabled');
                            } else if (groupId !== justChanged) {
                                o.attr('hidden', '1');
                                o.attr('disabled', '1');
                            }
                        }
                    }
                } else {
                    this.selected[groupId] = undefined;
                    s.hide();
                    $(`label[for='${s.attr('id')}']`).hide();

                }
            }
            if (allHidden) {
                for (const s of this.sel) {
                    s.selectedIndex = 0;
                }
                this._disable();
            } else {
                let sum = 0;
                for (const groupId of Object.keys(this.selected)) {
                    if (this.selected[groupId])
                        sum += this.selected[groupId];
                }

                let found = null;
                for (const option of this.product.options) {
                    if (option.bits === sum) {
                        found = option;
                        break;
                    }
                }

                if (found !== null) {
                    let max = found.stock;

                    if (this.productStock) {
                        for (const stock of this.productStock) {
                            if (stock.productToOption === found.productToOption && stock.bits === found.bits) {
                                max = stock.stock.remaining;
                                break;
                            }
                        }
                    }

                    this._updateMax(max);
                    if (max === 0) {
                        this.soldOut.show();
                        this._disable();
                    } else {
                        this._enable(found);
                    }

                } else {
                    this._disable();
                }
            }
        }
    }

    _disable() {
        if (this.enabled) {
            this.inpq.addClass('disabled');
            this.inpq.attr('disabled', '1');
            this.buyBtn.addClass('disabled');
            this.soldOut.hide();
            this.chosenProductToOption.val('');
            this.chosenBitSum.val('');
            this.productToOptionWithIndex.val('');
            this.bitSumWithIndex.val('');
            this.secondaryDecBtn.hide();
            this.secondaryIncBtn.hide();
            this.addonIncButton.disabled = true;
            this.incBtn.prop('disabled', true);
            this.incBtn.addClass('disabled');
            this.decBtn.prop('disabled', true);
            this.decBtn.addClass('disabled');
            if (this.buyBtnTicketSelect) {
                this.buyBtnTicketSelect.disabled = true;
            }
            this.enabled = false;
            this._resetNumItems();
            this.secondaryInp.text('');
        }
    }

    _enable(choice) {
        this.inpq.removeClass('disabled');
        this.inpq.removeAttr('disabled');
        this.buyBtn.removeClass('disabled');
       
        this.soldOut.hide();
        this.chosenProductToOption.val(choice.productToOption);
        this.chosenBitSum.val(choice.bits);
        this.productToOptionWithIndex.val(choice.productToOption);
        this.bitSumWithIndex.val(choice.bits);
        this.secondaryDecBtn.show();
        this.secondaryIncBtn.show();
        this.addonIncButton.disabled = false;
        this.incBtn.prop('disabled', false);
        this.incBtn.removeClass('disabled');

        this.enabled = true;
        let num = 1;
        if (this.ticketView) {
            num = this.getSizedProductQuantityFromForm();
        }
        this._resetNumItems(num);

        this._enableBuyBtn();

    }

    _enableBuyBtn() {
        if (this.numItems > 0) {
            this.buyBtn.removeClass('disabled');
            this.buyBtn.find('button').prop('disabled', false);
            if (this.buyBtnTicketSelect) {
                this.buyBtnTicketSelect.disabled = false;
            }
        }
    }

    _onIncrement() {
        if (!this.enabled) {
            return false;
        }
        if (this._getCartItems() + this.numItems >= this.maxOrderItems) {
            return false;
        }

        this.numItems++;
        if (this.numItems > this.maxItems) {
            this.numItems = this.maxItems;
        }
        if (this.ticketView && this.isGift && !this.productPrice && !this.chosenPrice) {
            this.showGiftPriceModal();
        }
        this.decBtn.prop('disabled', false);
        this.decBtn.removeClass('disabled');
        this._enableBuyBtn();

        this._updateNumItems();
    }

    _onDecrease() {

        if (!this.enabled) {
            return false;
        }

        this.numItems--;

        if (this.numItems < 1) {
            this.numItems = 0;
            this.buyBtn.addClass('disabled');
            this.buyBtn.find('button').prop('disabled', true);
            this.decBtn.prop('disabled', true);
            this.decBtn.addClass('disabled');
            if (this.buyBtnTicketSelect) {
                this.buyBtnTicketSelect.disabled = true;
            }
        }       
        this._updateNumItems();
    }

    _updateMax(newMax) {
        if (newMax > this.productMax)
            newMax = this.productMax;
        this.maxItems = newMax;

        if (this.numItems && this.numItems > newMax) {
            this.numItems = newMax;
            this._updateNumItems();
        }

        //For new select tickets addons
        const inputSelector = this._getAddonInput(this.product.productId);
        if (inputSelector) {
            inputSelector.attr('data-max', newMax);
        }
    }
    _getAddonInput(productId) {
        if (productId) {
            const $input = $('#addon-' + productId);
            if ($input.length > 0) {
                return $input;
            }
        }
        return null;
    }
    _resetNumItems(inp) {
        this.numItems = inp ? inp : null;
        this._updateNumItems();
    }
    _updateNumItems() {
        if (!this.numItems || this.numItems < 1) {
            this.numItems = 0;
        }
        this.inpq.val(this.numItems);
        this.inpq.attr('aria-label', `Antalet valda: ${this.numItems}`);

        this.chosenQuantity.val(this.numItems);

        if (this.ticketView) {
            this.setFormInput();
            this.secondaryInp.text(this.numItems);
            var findTicketsButton = $('.find-tickets .btn-find-tickets')
            if (findTicketsButton.css('display') === 'none') {
                if ($('#selected-products li').length > 0) {
                    this.continueButton.css('display', 'block')
                } else {
                    this.continueButton.css('display', 'none')
                }
            }
        }
    }

    _getCartItems() {
        var cartItems = $(".cart-items").first().html();
        var parsed = parseInt(cartItems);
        if (isNaN(parsed)) {
            return 0;
        }
        return parsed;
    }

    showGiftPriceModal() {
        const modalEl = document.getElementById(`modal-${this.productId}`);
        if (modalEl) {
            const modal = modalEl.modal = modalEl.modal ;

            const amount = modalEl.querySelector('.gift-amount-input');
            const btn = modalEl.querySelector('.accept-gift-amount');

            if (amount && btn) {
                const handler = (ev) => {
                    ev.preventDefault();
                    if (amount.checkValidity && amount.checkValidity()) {
                        btn.removeEventListener('click', handler);

                        if (amount.value) {
                            this.chosenPrice = amount.value * 1;
                            this.price.text(formatCurrency(this.chosenPrice));
                            modal.onCloseModal();
                            this.setFormInput();

                            this.chooseGiftAmountBtn.hide();
                            this.chooseGiftQuantityEl.show();
                        }
                    }
                };
                btn.addEventListener('click', handler);
                modal.onOpenModal();
                amount.focus();
            }
        }
    }

    setFormInput() {
        let name = '';
        if (this.sizedProduct) {
            name = 'ttd_product_sized_' + this.productId + '_' + this.chosenProductToOption.val()
                + '_' + this.chosenBitSum.val();
        } else if (this.isGift) {
            if (!this.productPrice && this.chosenPrice) {
                name = 'ttd_product_gift_' + this.productId + '_' + this.chosenPrice;
                var oldName = 'ttd_product_gift_' + this.productId;
                $(oldName).remove();
            } else {
                name = 'ttd_product_gift_' + this.productId;
            }
        } else {
            name = 'ttd_product_regular_' + this.productId;
        }

        if (this.numItems > 0) {
            let el = $('#' + name)
            if (el.length > 0) {
                el.val(this.numItems)
            } else {
                let el = $('<input type="hidden" />')
                el.attr('name', name)
                el.attr('id', name)
                el.val(this.numItems)
                $('#ticket-form').append(el)
            }
        } else {
            $('#' + name).remove()
        }

        if (this.ticketView) {
            this.setProductList();
        }
    }

    setProductList() {
        let name = '';
        if (this.sizedProduct) {
            name = 'prod-' + this.productId + '-' + this.chosenProductToOption.val() + '-' + this.chosenBitSum.val();
        } else {
            name = 'prod-' + this.productId;
        }

        let existing = $('#' + name);

        if (this.numItems > 0) {
            $('#selected-products').removeClass('hidden');
            let prodName = this.productName;

            if (this.sizedProduct) {
                let choices = this.product.options.find(x => x.bits == this.chosenBitSum.val()
                    && x.productToOption == this.chosenProductToOption.val()).groupChoices;

                $.each(choices, function (key, value) {
                    prodName += ' ' + value.name;
                });
            }

            if (existing.length) {
                existing.text(this.numItems + 'x ' + prodName);
            } else {
                let el = $('<li class="product-list-item">' + this.numItems + 'x ' + prodName + '</li>')
                el.attr('id', name)
                $('#selected-products ul').append(el);
            }
        } else if (existing.length > 0) {
            existing.remove();

            if ($('#selected-products li').length === 0) {
                $('#selected-products').addClass('hidden');
            }
        }
    }

    getSizedProductQuantityFromForm() {
        var result = $('#ticket-form #ttd_product_sized_' + this.productId + '_' + this.chosenProductToOption.val()
            + '_' + this.chosenBitSum.val());

        if (result.length) {
            return result.val();
        } else {
            return 0;
        }
    }
}
class ProductFilter {
    constructor(el, products) {
        this.el = el;
        this.products = products;
        this.categoryNames = [];
        this.filterList = this.el.find('ul');
        this.filterOptionChanged = this.filterOptionChanged.bind(this);

        $(this.products).each((index, el) => {
            if (this.categoryNames.indexOf(el.categoryName) === -1 && el.categoryName !== undefined) {
                this.categoryNames.push(el.categoryName);
            }
        });

        if (this.categoryNames.length > 1) {
            $(this.categoryNames).each((index, el) => {
                this.filterList.append('<li class="filter-option">' + el + '</li>');
            });

            this.el.find('.filter-option').on('click', this.filterOptionChanged)
        } else {
            this.el.addClass('hidden');
        }
    }

    filterOptionChanged(e) {
        var element = $(e.target);
        this.el.find('.filter-option').removeClass('selected');
        element.addClass('selected');
        var category = element.text();

        $(this.products).each((index, product) => {
            if (product.categoryName === category || this.categoryNames.indexOf(category) === -1) {
                product.el.removeClass('hidden');
            } else {
                product.el.addClass('hidden');
            }
        });
    }
}